import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="form--toggle-visibility"
export default class extends Controller {
  static targets = ["flag", "toggleElement", "postalAddressName"]

  connect() {
    this.toggleElementDisplay()
  }

  toggleElementDisplay() {
    if (this.flagTarget.checked) {
      this.toggleElementTarget.classList.remove("d-block")
      this.toggleElementTarget.classList.add("d-none")
    } else {
      this.toggleElementTarget.classList.remove("d-none")
      this.toggleElementTarget.classList.add("d-block")
      // Set name of postal address to address name — where the page has one. The
      // onboarding address step asks for the name a step earlier (LUC-900).
      const addressName = document.getElementById("address_name")
      if (this.hasPostalAddressNameTarget && addressName) {
        this.postalAddressNameTarget.value = addressName.value
      }
    }
  }
}
